import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgRatingStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.99631 0.175754C6.10481 -0.0594745 6.43913 -0.0594735 6.54763 0.175755L8.17576 3.70553C8.21998 3.8014 8.31083 3.8674 8.41568 3.87984L12.2758 4.33752C12.533 4.36802 12.6364 4.68597 12.4462 4.86185L9.59228 7.50105C9.51477 7.57273 9.48006 7.67954 9.50064 7.78309L10.2582 11.5957C10.3087 11.8498 10.0382 12.0463 9.81218 11.9198L6.42025 10.0211C6.32812 9.96956 6.21582 9.96956 6.1237 10.0211L2.73177 11.9198C2.50572 12.0463 2.23526 11.8498 2.28574 11.5957L3.04331 7.78309C3.06388 7.67954 3.02918 7.57273 2.95167 7.50105L0.0977731 4.86185C-0.0924144 4.68597 0.0108963 4.36802 0.268141 4.33752L4.12827 3.87984C4.23311 3.8674 4.32397 3.80139 4.36819 3.70553L5.99631 0.175754Z",
		fill: "black"
	})
});
export default SvgRatingStar;
